import { render, staticRenderFns } from "./score.vue?vue&type=template&id=d9353c40&scoped=true&"
import script from "./score.vue?vue&type=script&lang=js&"
export * from "./score.vue?vue&type=script&lang=js&"
import style0 from "./score.vue?vue&type=style&index=0&id=d9353c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9353c40",
  null
  
)

export default component.exports